import { VesselCertificateStatus } from '../types/core';
import { CrewMemberCertificate } from '../types/crew';
import { VesselCertificate } from '../types/vessel';
import { StatusIcon } from './icon';

export const hasPendingCertificates = (
  certificates: VesselCertificate[] | CrewMemberCertificate[],
): boolean =>
  !!certificates.find(
    ({ status }) => status === VesselCertificateStatus.PendingApproval,
  );

export const hasValidApprovedCertificates = (
  certificates: VesselCertificate[] | CrewMemberCertificate[],
): boolean =>
  !!certificates.find(
    ({ status, isExpired }) =>
      status === VesselCertificateStatus.Approved && !isExpired,
  );

export const getIconCertificateStatus = (
  isPending: boolean,
  certificates: VesselCertificate[] | CrewMemberCertificate[],
  isOptional = false,
) => {
  if (isPending) return StatusIcon.Pending;
  if (isOptional || hasValidApprovedCertificates(certificates)) {
    return StatusIcon.Completed;
  }
  return StatusIcon.Error;
};
